import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';

import { FormattedCurrency } from '@/components/Formatted/FormattedCurrency';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogBuyersPremium, getCatalogCurrency } from '@/redux/modules/catalog/catalogs/catalog.selectors';

import { DescriptionSection } from '../ItemDescription/DescriptionSection';

type Props = {
    catalogId: number;
};

const BuyersPremiumComponent = ({ catalogId }: Props) => {
    const { high, low, lowCutoff, middle, middleCutoff } = useAppSelector((state) =>
        getCatalogBuyersPremium(state, catalogId)
    );

    const currency = useAppSelector((state) => getCatalogCurrency(state, catalogId));

    return (
        <DescriptionSection
            body={
                <ul className="m-0 list-none p-0 print:!m-[0.5em_0]">
                    {Boolean(!(low && lowCutoff) && !middle && !high) && (
                        <li className="flex [&>div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.lowPercentage"
                                values={{ low }}
                            />
                        </li>
                    )}
                    {Boolean(low && lowCutoff) && (
                        <li className="flex [&>div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.lowCutOff"
                                values={{ low }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={lowCutoff}
                            />
                        </li>
                    )}
                    {Boolean(middle && middleCutoff) && (
                        <li className="flex [&>div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.middleCutOff"
                                values={{ middle }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={middleCutoff}
                            />
                        </li>
                    )}
                    {Boolean(middle && !middleCutoff) && (
                        <li className="flex [&>div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.middleLowCutOff"
                                values={{ middle }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={lowCutoff}
                            />
                        </li>
                    )}
                    {Boolean(high) && (
                        <li className="flex [&>div]:ml-[6px]">
                            <FormattedMessage
                                id="bidding_console.console.currentLiveItem.buyersPremium.highCutOff"
                                values={{ high }}
                            />{' '}
                            <FormattedCurrency
                                convert
                                sourceCurrency={currency}
                                value={middleCutoff}
                            />
                        </li>
                    )}
                </ul>
            }
            className="!mb-lg"
            header="bidding_console.console.currentLiveItem.headers.buyersPremium"
        />
    );
};

export const BuyersPremium = BuyersPremiumComponent;
